// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"1384":"dbea5493","4813":"d988b2e9","7575":"d988b2e9"}[chunkId] + ".chunk.css";
};